import React from 'react';
import Cart from '../components/Cart';
import Header from '../components/Header';

const CartPage = () => (
  <>
    <Header />
    <Cart />
  </>
);

export default CartPage;
